import React from "react";
import { useNavigate } from "react-router-dom";
import { Wrench, Crown, Sparkles, ArrowRight } from "lucide-react";

const ICON = { tool: Wrench, rank: Crown };
const LABEL = { tool: "TOOL UNLOCKED", rank: "STAGE UNLOCKED" };

// Unlock-moment standard: what it is, why it matters, where it lives, and a direct button into it.
export const UnlockCard = ({ u, i = 0 }) => {
  const navigate = useNavigate();
  const Icon = ICON[u.type] || Sparkles;
  return (
    <div data-testid={`unlock-card-${u.key || i}`} className="tc-card p-4 border-tc-mastery/30 bg-gradient-to-r from-tc-mastery/10 to-transparent animate-fade-up" style={{ animationDelay: `${i * 100}ms` }}>
      <div className="flex items-start gap-3">
        <div className="w-11 h-11 shrink-0 rounded-xl bg-tc-mastery/15 border border-tc-mastery/30 text-tc-mastery flex items-center justify-center"><Icon className="w-6 h-6" /></div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] font-mono uppercase tracking-widest text-tc-mastery">{LABEL[u.type] || "SKILL UNLOCKED"}</div>
          <div className="font-heading font-bold">{u.type === "rank" ? (u.copy || u.label) : u.label}</div>
          {u.what && u.type !== "rank" && <p className="text-[13px] text-tc-sub mt-1" data-testid={`unlock-what-${u.key}`}>{u.what}</p>}
          {u.why && <p className="text-[12px] text-tc-muted mt-1" data-testid={`unlock-why-${u.key}`}><span className="text-tc-mastery font-mono uppercase text-[10px]">Why it matters:</span> {u.why}</p>}
          {u.where && <p className="text-[12px] text-tc-muted mt-0.5" data-testid={`unlock-where-${u.key}`}><span className="text-tc-mastery font-mono uppercase text-[10px]">Where:</span> {u.where}</p>}
        </div>
      </div>
      {u.to && (
        <button data-testid={`unlock-open-${u.key}`} onClick={() => navigate(u.to)}
          className="mt-3 w-full sm:w-auto rounded-lg bg-tc-mastery/15 border border-tc-mastery/40 text-tc-mastery text-sm font-semibold px-4 py-2 hover:bg-tc-mastery/25 flex items-center justify-center gap-1.5">
          Open {u.where} <ArrowRight className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
};

export const UnlockList = ({ unlocks }) => unlocks?.length > 0 && (
  <div className="grid gap-3" data-testid="mission-unlocks">
    {unlocks.map((u, i) => <UnlockCard key={`${u.type}-${u.key}-${i}`} u={u} i={i} />)}
  </div>
);

export default UnlockCard;
